export default __webpack_public_path__ + "onboardingAbout.2eed146a.png";